var map = {
	"./common/banner-button-text.svg": "38a2",
	"./common/banner-button.svg": "4498",
	"./common/banner-hover-button.svg": "81bd",
	"./common/close.svg": "4ded",
	"./common/foot-button.svg": "71bc",
	"./common/foot-hover-button.svg": "7368",
	"./common/foot-line.svg": "6886",
	"./common/ita-logo.svg": "4620",
	"./common/modal-close.svg": "8d55",
	"./common/title-black.svg": "c91d",
	"./common/title-white.svg": "0d3b7",
	"./console/goldIdentificationStep.svg": "903d",
	"./console/oppo.svg": "3635",
	"./console/vivo.svg": "7e07",
	"./console/xiaomiLogo.svg": "1d1b",
	"./home/ITGSA大屏设备应用适配白皮书.svg": "ee1b",
	"./home/ITGSA大屏设备应用适配白皮书6.svg": "4478",
	"./home/OPPO.svg": "e0e1",
	"./home/detail-button-hover.svg": "8b7e",
	"./home/detail-button.svg": "8e18",
	"./home/document-button-hover.svg": "f940",
	"./home/document-button.svg": "1773",
	"./home/line.svg": "42a3",
	"./home/service-icon.svg": "26c9",
	"./home/start.svg": "4256",
	"./home/vivo.svg": "91d9",
	"./home/个人信息保护标准.svg": "4597",
	"./home/兼容性标准.svg": "7437",
	"./home/兼容性标准0.svg": "df55",
	"./home/功耗标准.svg": "b54d",
	"./home/功耗标准3.svg": "f2d4",
	"./home/地震预警服务规范.svg": "c64f",
	"./home/地震预警服务规范5.svg": "383a",
	"./home/安全标准.svg": "9366",
	"./home/安全标准4.svg": "0d8a",
	"./home/小米logo.svg": "37dd",
	"./home/性能标准.svg": "b06a",
	"./home/性能标准2.svg": "3e37",
	"./home/稳定性标准.svg": "0631",
	"./home/稳定性标准1.svg": "adfa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf8d";